import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { BoardCard } from "@fry/boards/lib";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReactiveFormsModule, Validators } from "@angular/forms";

import { MaterialModule } from "@fry/components/material";
import { EasFormModule } from "@fry/components/common/easform/easform.module";
import { EasFormService, EasFieldControl, EasFieldType, EasFormGroup } from "@fry/components/common/easform";
import { TextCardOptions } from "@fry/components/common/text-card/text-card";

export interface TitleCardOptions {
    title: string;
}

@Component({
    selector: 'eas-title-card-settings',
    templateUrl: './title-card.settings.component.html',
    imports: [
    MaterialModule,
    EasFormModule,
    ReactiveFormsModule
],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleCardSettingsComponent {

    dialogRef = inject(MatDialogRef<TitleCardSettingsComponent>);
    data: { options: TitleCardOptions, card: BoardCard } = inject(MAT_DIALOG_DATA);
    options = this.data.options;
    card = this.data.card;

    private formService = inject(EasFormService);
    private formFields: EasFieldControl[] = [
        {
            id: 'title',
            title: $localize `Title`,
            type: EasFieldType.Field,
            validators: [Validators.required],
            widget: { type: 'string' },
        }
    ];

    public form!: EasFormGroup;

    constructor() {
        this.form = this.formService.createForm(this.formFields, this.options);
    }

    onCancel() {
        this.dialogRef.close();
    }

    onSave() {
        const value = this.form.getValue();
        const options: TextCardOptions = {
            title: value.title,
            paragraph: value.paragraph
        }
        this.dialogRef.close(options);
    }

}